import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { NextRouter } from "next/router"

export const RIGHT_MODAL_CLOSE_CLICKED = "rightModal/close/clicked"

export const rightModalCloseClicked = (router: NextRouter) => ({
    type: RIGHT_MODAL_CLOSE_CLICKED,
    payload: {
        router: router,
    },
})

export const URL_CHANGED = "URL_CHANGED"

export const urlChanged = (query: Maybe<Record<string, any>>, asPath: Maybe<string>, pathname: Maybe<string>) => ({
    type: URL_CHANGED,
    payload: {
        query: query,
        asPath: asPath,
        pathname: pathname,
    },
})
